import styled from 'styled-components';
import { Table } from 'antd';
import { TableLabel } from '../../styles';
import { PrimaryButtonComponent, SectionLastHeading } from "../../../../../../CommonComponents/commonStyles";

export const PrimaryButton = styled(PrimaryButtonComponent)`
  width:300px;
`;

export const Text = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: : ${props => props.theme.fontWeight.normal};
  font-stretch: : ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.thead};
`;

export const UnderlineLink = styled.a`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h5};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.primary};
  text-decoration: underline !important;
  &:hover{
    color: ${props => props.theme.fontColors.primary};
  } 
`;

export const NoResult = styled.div`
  text-align:center;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: : ${props => props.theme.fontWeight.normal};
  font-stretch: : ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.textColor};
`;

export const IconPadding = styled.div`
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  margin-right: ${props => (props.primary ? '50px' : '')};
  @media (max-width: 990px) {
    margin-left: 0px;
    margin-right: 20px;
  }
`;

export const SearchTableLabel  = styled(TableLabel).attrs(()=>({
  className: "scrollUp"
  }))`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.headingColor} !important;
`

export const UnderlyingContent = styled(UnderlineLink)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.tableFont};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const SectionHeading = styled(SectionLastHeading)`
  font-stretch: normal;
  line-height: ${props => props.theme.lineHeight.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h4};
    line-height: ${props => props.theme.lineHeight.h4};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
`

export const GrantsTable = styled(Table)`
  .ant-table-thead
    > tr
    > th.ant-table-column-has-actions.ant-table-column-has-sorters,
  .ant-table-thead
    > tr
    > th.ant-table-column-has-actions.ant-table-column-has-filters {
    padding-right: 0px !important;
  }
  .ant-table-tbody > tr > td {
    border: none !important;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    padding: 20px 0px 20px 20px !important;
  }
  .ant-table-tbody > tr > td:last-child {
    padding: 20px 20px 20px 20px !important;
  }
  .ant-table-thead > tr > th .ant-table-header-column {
    letter-spacing: 0px;
  }

  .ant-table-thead > tr > th {
    padding: 20px 0px 20px 20px !important;
  }
  .ant-table-tbody > tr:nth-child(odd) {
    background-color: #f4f3f3;
  }
  .ant-table-fixed-header {
    .ant-table-scroll {
      .ant-table-header {
        padding-bottom: 0px !important;
        margin-bottom: -6px !important;
        background: #ffffff;
      }
      border-width: 0px 1px 1px 1px !important;
      // border-style: solid !important;
      border-color: #eaeaea !important;
    }
  }

  th {
    background: #fff !important;
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-style: normal;
    font-stretch: ${props => props.theme.fontStretch.normal};
    color: ${props => props.theme.fontColors.headingColor} !important;
    font-size: ${props => props.theme.fontSize.primary};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.38;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }

  .ant-table-thead {
    tr {
      th {
        .ant-table-column-sorter {
          left: 0px;
          right: 0px;
          top: 11px;
        }
        border-bottom-width: 2px;
        border-bottom-style: solid;
        border-bottom-color: #eaeaea;
      }
    }
  }
  ${({ ColorLess, theme }) =>
    ColorLess &&
    `
.ant-table-tbody > tr:nth-child(odd) {
  background-color: ${theme.colors.white}!important;
}
.ant-table-thead >tr >th: first-child {
  padding-left: 0px!important;
}
.ant-table-thead >tr >th {
  border-bottom-width: 1px!important;
  border-bottom-color: ${theme.border.pill}!important;
}
.ant-table-tbody > tr > td{
  border: none !important;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  padding: 7.5px 0px 7.5px 20px !important;
}
.ant-table-tbody > tr > td: first-child{
  padding-left: 0px !important;
}
.ant-table-tbody > tr:first-child{
  padding: 9.5px 0px 0px 0px !important;
}
.ant-table-tbody > tr > td:last-child{
  padding: 20px 0px 20px 20px !important
}
`}
`;
